import { createContext } from "react";
const RoomCategoryMasterContext = createContext({});
export default RoomCategoryMasterContext;
